/**
 * FormTextareaField Component
 * Reusable textarea form field with consistent styling
 *
 * Features:
 * - Consistent label and textarea styling
 * - Built-in error state and messaging
 * - Optional helper text
 * - Required field indicator
 * - Configurable rows
 * - Vertical resize only
 */

import { FORM_GROUP_STYLE, TEXTAREA_STYLE, LABEL_STYLE } from '../../styles/modalStyles';

export interface FormTextareaFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  helperText?: string;
  rows?: number;
}

export function FormTextareaField({
  label,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  error,
  helperText,
  rows = 3,
}: FormTextareaFieldProps) {
  return (
    <div style={FORM_GROUP_STYLE}>
      <label style={LABEL_STYLE}>
        {label}
        {required && <span style={{ color: '#ef4444', marginLeft: '4px' }}>*</span>}
      </label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        style={{
          ...TEXTAREA_STYLE,
          borderColor: error ? '#ef4444' : '#d1d5db',
          backgroundColor: disabled ? '#f9fafb' : '#ffffff',
          cursor: disabled ? 'not-allowed' : 'text',
        }}
      />
      {error && (
        <span style={{
          display: 'block',
          marginTop: '4px',
          fontSize: '12px',
          color: '#ef4444',
        }}>
          {error}
        </span>
      )}
      {helperText && !error && (
        <span style={{
          display: 'block',
          marginTop: '4px',
          fontSize: '12px',
          color: '#6b7280',
        }}>
          {helperText}
        </span>
      )}
    </div>
  );
}
